import { Component } from '@angular/core';

@Component({
  selector: 'wsb-partner-client-setup',
  templateUrl: './partner-clientsetup.component.html',
  styleUrls: ['./partner-clientsetup.component.scss'],
  standalone: false
})
export class PartnerClientSetupComponent {
  activeId = 1;

  constructor() {}
}
